import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { forgotPassword } from '../api/portalApi';

const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : t('forgotPassword.failed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="investor-login-shell">
      <div className="investor-login-logo">
        <img src="/logos/nomadme_sourcing_trading_mark.png" alt="nomadme" />
      </div>
      <p className="investor-login-brand">NomadMe</p>

      <section className="investor-login-card">
        <Link to="/login" className="auth-back-link">{t('forgotPassword.backToLogin')}</Link>
        <h2>{t('forgotPassword.title')}</h2>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <div style={{ fontSize: '2rem', marginBottom: 12 }}>📬</div>
            <p style={{ color: '#94a3b8', lineHeight: 1.6 }}>
              {t('forgotPassword.sent')}
            </p>
            <Link to="/login" style={{ color: '#c8a06a', fontSize: '0.9rem', textDecoration: 'none', marginTop: 16, display: 'block' }}>
              {t('forgotPassword.returnToLogin')}
            </Link>
          </div>
        ) : (
          <>
            <p className="investor-login-subtitle">{t('forgotPassword.sub')}</p>
            <form className="investor-login-form" onSubmit={handleSubmit}>
              <div className="investor-login-field">
                <label htmlFor="email">{t('forgotPassword.emailAddress')}</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  autoComplete="email"
                />
              </div>
              {error && <p className="investor-login-error">{error}</p>}
              <button type="submit" disabled={isLoading} className="investor-login-btn">
                {isLoading ? t('forgotPassword.sending') : t('forgotPassword.sendLink')}
              </button>
            </form>
          </>
        )}
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
